import { createFileRoute } from "@tanstack/react-router";

import { VerificationEmailLogsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/verification/email-logs")({
  component: VerificationEmailLogsPage,
});
